import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "@environments/environment";

import { NotificationRequest } from "../Interfaces/Notificaciones/notification-request.interface";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  public sendNotification(data: NotificationRequest): Observable<void> {
    return this.http.post<void>(`${environment.enlineaBackendUrl}/api/Notificaciones/EnviarNotificacionesMasivas`, data);
  }
}
